import { Fragment, useState, useEffect } from "react";
import axios from "axios";
import "./css/taller.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
// import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Layout from "./Layout";
import Ancla from "../../images/assets/ancla.png";
import Taller from "../../images/assets/taller-icon.png";
import { GoogleKeyAPI, Server } from "../../constants";

function InfoTaller() {
  const [ciudades, setCiudades] = useState([]);
  const [ciudad, setCiudad] = useState("100");
  const [ciudadesPoint, setCiudadesPoint] = useState([]);
  const [concesionarios, setConcesionarios] = useState([]);
  const [concesionarioC, setConcesionarioc] = useState([]);
  const [concesionario, setConcesionario] = useState("");
  const [latitud, setLatitud] = useState(-1.8798743);
  const [longitud, setLongitud] = useState(-78.6103923);
  const [zoom, setZoom] = useState(7);

  useEffect(() => {
    if (ciudades.length === 0) {
      const getCiudades = async () => {
        const url = `${Server}/api/ciudades_select/2-3`;
        const resultado = await axios.get(url);
        setCiudades(resultado.data);
      };
      getCiudades();
      if (ciudad === "100") {
        const getCiudadesPoint = async () => {
          const url = `${Server}/api/ciudades_point/2-3`;
          const resultado = await axios.get(url);
          setCiudadesPoint(resultado.data);
        };
        getCiudadesPoint();
      }
    }
  }, [ciudades.length, ciudad]);

  const onChangeCiudad = async (e) => {
    setCiudad(e.target.value);
    const ciudadE = document.getElementById("ciudad").value;
    if (ciudadE !== "100") {
      const getCiudadMapa = async () => {
        const url = `${Server}/api/ciudad_mapa/${ciudadE}`;
        const resultado = await axios.get(url);
        setCiudad(resultado.data[0].CIU_CODIGO);
        setLatitud(resultado.data[0].CIU_LATITUD);
        setLongitud(resultado.data[0].CIU_LONGITUD);
        setZoom(resultado.data[0].CIU_ZOOM);
      };
      getCiudadMapa();
      const getConcesionariosPoint = async () => {
        const url = `${Server}/api/concesionarios_point_talleres/${ciudadE}/2-3`;
        const resultado = await axios.get(url);
        setConcesionarios(resultado.data);
      };
      getConcesionariosPoint();
    } else {
      setCiudad("100");
      setLatitud(-1.8798743);
      setLongitud(-78.6103923);
      setZoom(7);
      const getCiudadesPoint = async () => {
        const url = `${Server}/api/ciudades_point/2-3`;
        const resultado = await axios.get(url);
        setCiudadesPoint(resultado.data);
      };
      getCiudadesPoint();
    }
  };

  const onChangeConcesionario = async (e) => {
    setConcesionario(e.target.value);
    let cons = e.target.value.split("/");
    let empresa = parseInt(cons[0]);
    let codigo = parseInt(cons[1]);
    const s = [];
    const ss = [];
    // Concesionario
    concesionarios.forEach(function (number, i) {
      let idC =
        concesionarios[i].ALM_EMPRESA + "/" + concesionarios[i].ALM_CODIGO;
      if (
        concesionarios[i].ALM_EMPRESA === empresa &&
        concesionarios[i].ALM_CODIGO === codigo
      ) {
        s.push(concesionarios[i]);
        document.getElementById(idC).className = "agencia-active";
        // Spreed Operator
        ss.push(concesionarios[i]);
      } else {
        document.getElementById(idC).className = "card";
      }
    });
    concesionarios.forEach(function (number, i) {
      if (
        concesionarios[i].ALM_EMPRESA !== empresa ||
        concesionarios[i].ALM_CODIGO !== codigo
      ) {
        s.push(concesionarios[i]);
      }
    });
    setConcesionarios(s);
    setConcesionarioc(ss);
  };

  const clickConcesionario = (empresa, almacen, latitud, longitud, zoom) => {
    concesionarios.forEach(function (number, i) {
      let idC =
        concesionarios[i].ALM_EMPRESA + "/" + concesionarios[i].ALM_CODIGO;
      if (
        concesionarios[i].ALM_EMPRESA === empresa &&
        concesionarios[i].ALM_CODIGO === almacen
      ) {
        document.getElementById(idC).className = "agencia-active";
      } else {
        document.getElementById(idC).className = "card";
      }
      setLatitud(latitud);
      setLongitud(longitud);
      setZoom(zoom);
    });
  };

  return (
    <Fragment>
      <div className="bg-concesionario">
        <Container fluid={true} className="cont-concesionario py-4 px-md-5">
          <Row className="sr-only">
            <Col md={12} className="text-center mt-4 mt-md-5">
              <h1>Hyundai Ecuador Red de Talleres</h1>
            </Col>
          </Row>
          <Row>
            <Col md={3} className="cont-agencia pl-md-0">
              <Form>
                <Form.Row>
                  <Form.Group as={Col} md="12">
                    <Image
                      src={Ancla}
                      alt="Icono ancla"
                      className="ancla-icon"
                      fluid
                    />
                    <Form.Label>Ciudad</Form.Label>
                    <Form.Control
                      as="select"
                      name="ciudad"
                      id="ciudad"
                      className="custom-select"
                      value={ciudad}
                      onChange={onChangeCiudad}
                    >
                      <option value="100" key="100">
                        - Ciudad -
                      </option>
                      {ciudades.map((ciudad) => (
                        <option
                          key={ciudad.CIU_CODIGO}
                          value={ciudad.CIU_CODIGO}
                        >
                          {ciudad.CIU_NOMBRE}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                  <Form.Group as={Col} md="12" className="d-block d-sm-none">
                    <Image
                      src={Taller}
                      alt="Icono leyenda"
                      className="leyenda-icon"
                      fluid
                    />
                    <Form.Label>Concesionarios</Form.Label>
                    <Form.Control
                      as="select"
                      name="concesionario"
                      id="concesionario"
                      className="custom-select"
                      value={concesionario}
                      onChange={onChangeConcesionario}
                    >
                      <option key="0" value="0">
                        - Concesionario -
                      </option>
                      {ciudad !== "100"
                        ? concesionarios.map((concesionario) => (
                          <option
                            key={
                              concesionario.ALM_EMPRESA /
                              concesionario.ALM_CODIGO
                            }
                            value={
                              concesionario.ALM_EMPRESA +
                              "/" +
                              concesionario.ALM_CODIGO
                            }
                          >
                            {concesionario.EMP_NOMBRE_COMERCIAL}/
                            {concesionario.ALM_NOMBRE}
                          </option>
                        ))
                        : null}
                    </Form.Control>
                  </Form.Group>
                </Form.Row>
              </Form>
              <Row className="d-none d-sm-block">
                <Col md={12} className="mt-2">
                  <Image
                    src={Taller}
                    alt="Icono leyenda"
                    className="leyenda-icon"
                  />
                  <Form.Label>Taller</Form.Label>
                </Col>
              </Row>
              <Row className="d-none d-sm-block">
                <Col md={12}>
                  {ciudad === "100" ? (
                    <Card>
                      <Card.Body>
                        <Card.Title className="agencia-nombre">
                          Hyundai Ecuador
                        </Card.Title>
                        <Card.Text>
                          Seleccione la ciudad para ver su concesionario cercano
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  ) : (
                    concesionarios.map((concesionario) => (
                      <Card
                        id={
                          concesionario.ALM_EMPRESA +
                          "/" +
                          concesionario.ALM_CODIGO
                        }
                        key={
                          concesionario.ALM_EMPRESA / concesionario.ALM_CODIGO
                        }
                        onClick={() =>
                          clickConcesionario(
                            concesionario.ALM_EMPRESA,
                            concesionario.ALM_CODIGO,
                            concesionario.ALM_LATITUD_MAPA,
                            concesionario.ALM_LONGITUD_MAPA,
                            concesionario.ALM_ZOOM
                          )
                        }
                      >
                        <Card.Body>
                          <Card.Title className="agencia-nombre">
                            <strong>Agencia: </strong>
                            {concesionario.EMP_NOMBRE_COMERCIAL}/
                            {concesionario.ALM_NOMBRE}
                          </Card.Title>
                          <Card.Text className="agencia-direccion">
                            <strong>Dirección: </strong>
                            {concesionario.ALM_DIRECCION}
                          </Card.Text>
                          <Card.Text className="agencia-direccion">
                            <strong>Teléfono: </strong>
                            {concesionario.ALM_TELEFONO}
                          </Card.Text>
                          <Card.Text className="agencia-direccion">
                            <strong>Horario Lunes a Viernes: </strong>
                            {concesionario.ALM_HORARIO_LUN_VIER_TALLER}
                          </Card.Text>
                          <Card.Text className="agencia-direccion">
                            <strong>Horario Sábados: </strong>
                            {concesionario.ALM_HORARIO_SAB_TALLER}
                          </Card.Text>
                          <Card.Text className="agencia-direccion">
                            <strong>Horario Domingos: </strong>
                            {concesionario.ALM_HORARIO_DOM_TALLER}
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    ))
                  )}
                </Col>
              </Row>
              <Row className="d-block d-sm-none">
                <Col md={12}>
                  {ciudad === "100" ? (
                    <Card>
                      <Card.Body>
                        <Card.Title className="agencia-nombre">
                          Hyundai Ecuador
                        </Card.Title>
                        <Card.Text>
                          Seleccione la ciudad para ver su concesionario cercano
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  ) : (
                    concesionarioC.map((concesionarioc) => (
                      <Card
                        id={
                          concesionarioc.ALM_EMPRESA +
                          "/" +
                          concesionarioc.ALM_CODIGO +
                          "c"
                        }
                        key={
                          concesionarioc.ALM_EMPRESA /
                          concesionarioc.ALM_CODIGO +
                          "c"
                        }
                      >
                        <Card.Body>
                          <Card.Title className="agencia-nombre">
                            <strong>Agencia: </strong>
                            {concesionarioc.EMP_NOMBRE_COMERCIAL}/
                            {concesionarioc.ALM_NOMBRE}
                          </Card.Title>
                          <Card.Text className="agencia-direccion">
                            <strong>Dirección: </strong>
                            {concesionarioc.ALM_DIRECCION}
                          </Card.Text>
                          <Card.Text className="agencia-direccion">
                            <strong>Teléfono: </strong>
                            {concesionarioc.ALM_TELEFONO}
                          </Card.Text>
                          <Card.Text className="agencia-direccion">
                            <strong>Horario Lunes a Viernes: </strong>
                            {concesionarioc.ALM_HORARIO_LUN_VIER_TALLER}
                          </Card.Text>
                          <Card.Text className="agencia-direccion">
                            <strong>Horario Domingos: </strong>
                            {concesionarioc.ALM_HORARIO_DOM_TALLER}
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    ))
                  )}
                </Col>
              </Row>
            </Col>
            <Col md={9} className="mt-4 mt-md-0">
              {ciudad === "100" ? (
                <Layout
                  x={latitud}
                  y={longitud}
                  z={zoom}
                  apikey={GoogleKeyAPI}
                  ciudad={ciudad}
                  setCiudad={setCiudad}
                  setLatitud={setLatitud}
                  setLongitud={setLongitud}
                  setZoom={setZoom}
                  concesionarios={ciudadesPoint}
                  ciudadesPoint={ciudadesPoint}
                  setConcesionarios={setConcesionarios}
                  setConcesionario={setConcesionario}
                  setConcesionarioc={setConcesionarioc}
                />
              ) : (
                <Layout
                  x={latitud}
                  y={longitud}
                  z={zoom}
                  apikey={GoogleKeyAPI}
                  ciudad={ciudad}
                  setCiudad={setCiudad}
                  setLatitud={setLatitud}
                  setLongitud={setLongitud}
                  setZoom={setZoom}
                  concesionarios={concesionarios}
                  ciudadesPoint={ciudadesPoint}
                  setConcesionarios={setConcesionarios}
                  setConcesionario={setConcesionario}
                  setConcesionarioc={setConcesionarioc}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
}
export default InfoTaller;